<template>
  <v-footer
      dark
      padless
    >
      <v-card
        flat
        tile
        class="dark lighten-1 white--text text-center"
        width="100%"
      >
        <v-card-text>
          <v-btn
            fab
            v-for="icon in icons"
            :key="icon"
            small
            style="margin:2px"
          >
            <v-icon size="24px">{{ icon }}</v-icon>
          </v-btn>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — <strong>Professional Insurance Corporation</strong>
        </v-card-text>
      </v-card>
    </v-footer>
</template>
<script>
  export default {
    name: 'SiteFooter',
    data: () => ({
      icons: [
        'mdi-facebook',
        'mdi-twitter',
        'mdi-google-plus',
        'mdi-linkedin',
        'mdi-instagram',
      ],
    })
  }
</script>